import { ApiError } from '@lib/network/api';

export const AUTH_ERROR_CODES = {
  turnstileInvalid: 'turnstile.invalid',
  magicLinkInvalid: 'user.magic_link.invalid',
  emailConflict: 'user.email.conflict',
} as const;

export const isTurnstileError = (e: unknown): boolean =>
  e instanceof ApiError &&
  (e.code === AUTH_ERROR_CODES.turnstileInvalid ||
    (e.status === 403 && e.message.includes('turnstile')));

// Moved to the network layer — the status pollers need it too. Re-exported so
// the auth forms' existing imports keep working.
export { isRateLimitError } from '@lib/network/api';
